import React from 'react';

import makeStyles from '@mui/styles/makeStyles';

import IconButton from '@mui/material/IconButton';

import BlockIcon from '@mui/icons-material/Block';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

interface BlockedIconProps {
  onClick: () => void;
}

const useStyles = makeStyles(
  {
    iconContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#EEE',
      display: 'flex',
      flexFlow: 'column',
      // textAlign: 'center',
    },
  },
  { name: 'VCBlockedIcon' },
);

const BlockedIcon: React.FC<BlockedIconProps> = ({ onClick }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.iconContainer}>
        <Stack spacing={2} alignItems="center">
          <IconButton onClick={onClick} size="large">
            <BlockIcon fontSize="large" htmlColor="white" />
          </IconButton>
          <Box sx={{ typography: 'subtitle2' }}>Access Denied</Box>
          <Box sx={{ typography: 'body2' }}>Please adjust your browser settings.</Box>
        </Stack>
      </div>
    </>
  );
};

export default BlockedIcon;
